import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  HANDOVER_NOTIFICATION_WELL_TYPE_OTHER_IDS,
  HANDOVER_TYPE_HLOC0_ID,
} from 'src/app/handover-constants';
import { DeliveryLocationWell } from 'src/app/interfaces/delivery-location-well';
import { DeliveryLocation } from 'src/app/interfaces/delivery-locations';
import { FileAttachment, Files } from 'src/app/interfaces/file';

import { Handover } from 'src/app/interfaces/handover';
import { WellType } from 'src/app/interfaces/notifications';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionTouched } from '../../shared/section-touched.class';
import {
  HandoverRelation,
  RelatedHandover,
} from 'src/app/interfaces/handover-relation';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-location-status',
  templateUrl: './handover-detail-location-status.component.html',
  styleUrls: ['./handover-detail-location-status.component.scss'],
  standalone: false,
})
export class HandoverDetailLocationStatusComponent
  extends SectionTouched
  implements OnInit, OnChanges
{
  @Input() handover: Handover | undefined;
  @Input() handoverRelation: HandoverRelation | undefined;
  @Input() readOnlyContent!: boolean;
  @Input() handoverTypeId: number | undefined;
  @Input() handoverTypeAreaReasonId: number | undefined;

  originalCheckDeliveryLocations: DeliveryLocation[] = [];
  originalTaskDeliveryLocations: DeliveryLocation[] = [];
  displayWellTypeSelector = false;
  checkDeliveryLocations: DeliveryLocation[] = [];
  taskDeliveryLocations: DeliveryLocation[] = [];
  isLoading = false;
  disableAddTask = false;
  wellTypes: WellType[] = [];
  LocationsavedId: number | undefined = 0;
  chosenWellType: WellType = {} as WellType;
  chosenDeliveryWellSelect: DeliveryLocationWell = {} as DeliveryLocationWell;
  displayOtherWellTypeInput = false;
  displayOtherDeliveryWell = false;
  displayhandoverType = false;
  otherWellTypeInput = '';
  otherWellTypes = HANDOVER_NOTIFICATION_WELL_TYPE_OTHER_IDS;
  handoverId: number | undefined = 0;
  deliveryWellSelect: DeliveryLocationWell[] = [];
  saved: DeliveryLocationWell[] = [];
  disablewellselect = true;
  o!: DeliveryLocationWell;
  deliveryLocationFiles: Files[] = [];
  fileLimit = 3;
  fileatttachment: Files[] = [];
  descripcion = '';
  fileatttachmentresult: any;
  isLoadingImages = false;
  buttonFile = false;
  uploadfile = false;
  controladortiempo = '';
  isHOLOC = false;
  relatedHandover: RelatedHandover = {} as RelatedHandover;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    public handoverService: HandoverService,
    public notificationService: NotificationService,
    public dialogService: DialogService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover?.handoverTypeId === HANDOVER_TYPE_HLOC0_ID) {
      this.displayhandoverType = true;
      this.retrievedeliveryLocationsWells();
    }

    this.retrieveDeliveryLocations();
    this.getFilesAttachments();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.handoverRelation && this.handoverRelation) {
      this.isHOLOC =
        this.handoverRelation.handoverLocationId === this.handover?.handoverId;
      if (
        (this.handoverRelation.handoverId === this.handover?.handoverId &&
          this.handoverRelation.handoverLocationId) ||
        (this.handoverRelation.handoverLocationId ===
          this.handover?.handoverId &&
          this.handoverRelation.handoverId)
      )
        this.getRelatedHandoverData();
    }
  }

  retrievedeliveryLocationsWells(): void {
    this.disablewellselect = true;
    this.handoverId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    this.handoverService
      .getDeliveryLocationsWellsaved(this.handoverId)
      .subscribe((deliveryLoctionWell) => {
        this.LocationsavedId = deliveryLoctionWell.deliveryLocationWellId; //Obtengo valor guardado
        this.handoverService
          .getDeliveryLocationsWell()
          .subscribe((DeliveryLocationsWell) => {
            this.deliveryWellSelect = DeliveryLocationsWell;
            this.chosenDeliveryWellSelect = this.deliveryWellSelect.filter(
              (elemento) =>
                elemento.deliveryLocationWellId == this.LocationsavedId
            )[0];
            if (this.chosenDeliveryWellSelect) {
              this.disablewellselect = false;
            }
          });
      });
  }

  onCheckDeliveryLocationChange(deliveryLocation: DeliveryLocation): void {
    this.onSectionTouched('deliveryLocation');
    this.emitPendingChanges(
      !this.deliveryLocationValuesAreEqual(
        deliveryLocation,
        this.originalCheckDeliveryLocations.filter(
          (deliveryValue) =>
            deliveryValue.locationStatusId == deliveryLocation.locationStatusId
        )[0]
      )
    );
  }

  onTaskDeliveryLocationChange(deliveryLocation: DeliveryLocation): void {
    this.onSectionTouched('deliveryLocation');
    this.emitPendingChanges(
      !this.deliveryLocationValuesAreEqual(
        deliveryLocation,
        this.originalTaskDeliveryLocations.filter(
          (deliveryValue) =>
            deliveryValue.handoverLocationStatusId ==
            deliveryLocation.handoverLocationStatusId
        )[0]
      )
    );
  }

  retrieveDeliveryLocations(): void {
    this.handoverId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    if (this.handover) {
      this.isLoading = true;
      this.handoverService
        .getDeliveryLocations(
          this.handoverRelation && this.handoverRelation.handoverLocationId
            ? this.handoverRelation.handoverLocationId
            : this.handover!.handoverId!,
          this.handover.wellManagementUnitId,
          this.handover.handoverTypeAreaReasonId
        )
        .subscribe((deliveryLocations) => {
          this.checkDeliveryLocations = deliveryLocations.filter(
            (deliveryValue) => deliveryValue.locationStatusId != null
          );
          this.checkDeliveryLocations.map((checkDeliveryLocation) => {
            this.originalCheckDeliveryLocations.push(
              Object.assign({}, checkDeliveryLocation)
            );
          });
          this.taskDeliveryLocations = deliveryLocations.filter(
            (deliveryValue) => deliveryValue.locationStatusId == null
          );
          this.taskDeliveryLocations.map((taskDeliveryLocation) => {
            this.originalTaskDeliveryLocations.push(
              Object.assign({}, taskDeliveryLocation)
            );
          });
          this.isLoading = false;
          // Determine if there is an already chosen well type...
          this.chosenWellType =
            this.wellTypes.find((value) => {
              return true === value.chosen;
            }) || this.chosenWellType;
          if (this.chosenWellType.wellTypeId) {
            // ...and make things happen for that choice.
            this.displayOtherWellTypeInput = this.otherWellTypes.includes(
              this.chosenWellType.wellTypeId
            );
            this.otherWellTypeInput = this.chosenWellType.otherValue || '';
            // this.retrieveNotifications();
          }
        });
    }
  }

  getRelatedHandoverData(): void {
    if (this.handover) {
      this.isLoading = true;
      this.handoverService
        .getRelatedHandoverData(this.handover.handoverId!)
        .subscribe((relatedHandover: RelatedHandover) => {
          this.relatedHandover = relatedHandover;
        });
      this.isLoading = false;
    }
  }

  onChangeDeliveyWellType(value: DeliveryLocationWell): void {
    this.displayOtherWellTypeInput = this.otherWellTypes.includes(
      value.deliveryLocationWellId
    );
    this.disablewellselect = false;
  }

  deliveryLocationValuesAreEqual(
    value1: DeliveryLocation,
    value2: DeliveryLocation
  ): boolean {
    return (
      value1.activeSelected === value2.activeSelected &&
      value1.agreedDate === value2.agreedDate &&
      value1.assignedUser === value2.assignedUser &&
      value1.complaintNumber === value2.complaintNumber &&
      value1.taskLabel === value2.taskLabel
    );
  }

  save(): void {
    const postDeliveryLocation: DeliveryLocation[] = [];
    if (this.checkDeliveryLocations.length > 0) {
      this.isLoading = true;
      for (let i = 0; i < this.checkDeliveryLocations.length; i++) {
        if (
          !this.deliveryLocationValuesAreEqual(
            this.checkDeliveryLocations[i],
            this.originalCheckDeliveryLocations.filter(
              (deliveryValue) =>
                deliveryValue.locationStatusId ==
                this.checkDeliveryLocations[i].locationStatusId
            )[0]
          )
        ) {
          this.checkDeliveryLocations[i].handoverId =
            this.handover!.handoverId!;
          postDeliveryLocation.push(this.checkDeliveryLocations[i]);
        }
      }
      if (postDeliveryLocation.length > 0) {
        if (this.handover) {
          this.handoverService
            .saveDeliveryLocations(
              postDeliveryLocation,
              this.handover!.handoverId!
            )
            .subscribe((savedDeliveryLocations: DeliveryLocation[]) => {
              if (savedDeliveryLocations) {
                this.notificationService.notify(
                  `Los cambios en Entrega de Locacion se han guardado con éxito.`,
                  true
                );
                this.originalCheckDeliveryLocations = [];
                this.emitPendingChanges(false);
                this.retrieveDeliveryLocations();
              } else {
                this.notificationService.notify(
                  `Ocurrió un error al grabar los cambios en Entrega de Locacion.`,
                  false
                );
              }
            });
        }
      }
      this.isLoading = false;
    } else {
      return;
    }
  }

  dateNow(): Date {
    return new Date(Date.now());
  }

  addTask(): void {
    const emptyTask = {} as DeliveryLocation;
    emptyTask.handoverLocationStatusId = null!;
    emptyTask.handoverId = this.handover?.handoverId;
    emptyTask.locationStatusId = null!;
    emptyTask.activeSelected = true;
    emptyTask.complaintNumber = null!;
    this.taskDeliveryLocations.push(emptyTask);
    this.originalTaskDeliveryLocations.push(Object.assign({}, emptyTask));
    this.disableAddTask = true;
  }

  saveTask(task: DeliveryLocation): void {
    if (
      !this.deliveryLocationValuesAreEqual(
        task,
        this.originalTaskDeliveryLocations.filter(
          (deliveryValue) =>
            deliveryValue.handoverLocationStatusId ==
            task.handoverLocationStatusId
        )[0]
      )
    ) {
      this.isLoading = true;
      if (this.handover) {
        if (
          !task.taskLabel ||
          task.taskLabel.trim() == '' ||
          !task.assignedUser ||
          task.assignedUser.trim() == '' ||
          !task.agreedDate
        ) {
          this.notificationService.notify(
            `Ocurrió un error al grabar los cambios en Entrega de Locacion. Revisar los campos obligatorios.`,
            false
          );
          this.isLoading = false;
          return;
        }
        this.handoverService
          .saveDeliveryLocations([task], this.handover!.handoverId!)
          .subscribe((savedDeliveryLocations: DeliveryLocation[]) => {
            if (savedDeliveryLocations) {
              this.originalTaskDeliveryLocations = [];
              this.retrieveDeliveryLocations();
              this.notificationService.notify(
                `Los cambios en Entrega de Locacion se han guardado con éxito.`,
                true
              );
              this.emitPendingChanges(false);
              this.disableAddTask = false;
            } else {
              this.notificationService.notify(
                `Ocurrió un error al grabar los cambios en Entrega de Locacion.`,
                false
              );
            }
            this.isLoading = false;
          });
      }
    }
  }

  saveDiscoverySelect(DeliverywellSelect: DeliveryLocationWell): void {
    this.handoverId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    this.handoverService
      .saveDeliveryLocationsWell(this.handoverId, DeliverywellSelect)
      .subscribe((savediscoverySelect) => {
        console.log(savediscoverySelect);
        if (savediscoverySelect) {
          this.disablewellselect = false;
        }
      });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    const file_description = this.descripcion;

    if (this.handover?.handoverId) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('filedescription', file_description);
      this.handoverService
        .saveFileAttachment(this.handover?.handoverId, formData)
        .subscribe(
          (uploaded: FileAttachment[]) => {
            if (uploaded) {
              this.uploadfile = true;
              this.descripcion = '';
              this.getFilesAttachments();
            }
          },

          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.isLoading = false;
    }
  }

  getFilesAttachments(): void {
    if (this.handoverId) {
      this.handoverService
        .getFiles(this.handoverId)
        .subscribe((file: FileAttachment[]) => {
          if (file) {
            this.fileatttachmentresult = file;
            this.buttonFile = true;
            this.uploadfile = true;
          }
        });
    }
  }

  deleteAttachment(filedete: any): void {
    if (!this.handover?.handoverId) {
      return;
    }
    this.isLoading = true;
    this.handoverService
      .deleteFileAttachment(this.handover?.handoverId, filedete)
      .subscribe((res: boolean) => {
        if (res) {
          delete this.fileatttachmentresult;
          this.getFilesAttachments();
        }
        this.isLoading = false;
      });
  }

  updateDescription(data: string, fileid: number): void {
    if (!this.handover?.handoverId) {
      return;
    }
    this.isLoading = true;
    this.handoverService
      .updatedescriptionfile(this.handover?.handoverId, data, fileid)
      .subscribe((Upload) => {
        if (Upload) {
          this.getFilesAttachments();
        } else {
          this.getFilesAttachments();
        }
      });
    this.isLoading = false;
  }

  deleteTask(task: DeliveryLocation): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Entrega de Locacion',
      `¿Está seguro de que desea eliminar la tarea?`
    );

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (task.handoverLocationStatusId) {
          this.isLoading = true;
          if (this.handover) {
            this.handoverService
              .deleteDeliveryLocation(
                this.handover!.handoverId!,
                task.handoverLocationStatusId!
              )
              .subscribe((boolean) => {
                if (boolean) {
                  this.notificationService.notify(
                    `La tarea en Entrega de Locacion se ha eliminado con éxito.`,
                    true
                  );
                  this.retrieveDeliveryLocations();
                } else {
                  this.notificationService.notify(
                    `Ocurrió un error al eliminar la tarea en Entrega de Locacion.`,
                    false
                  );
                }
                this.isLoading = false;
              });
          }
        } else {
          this.originalTaskDeliveryLocations.pop();
          this.taskDeliveryLocations.pop();
          this.disableAddTask = false;
        }
      }
    });
  }
}
